import React from 'react';
//components
import ComeHomeToNaturalGas from './Links/ComeHomeToNaturalGas';
import SaveMoreWithRebates from './Links/SaveMoreWithRebates';
import FindAGasContractor from './Links/FindAGasContractor';
import HowMuchCanISave from './Links/HowMuchCanISave';
import * as consts from '../../../constants';


const UsefulLinks = ({ lookup, pageName, isCrteditHistoryRequired ,offRamp}) => {
    return (

        <div>
            <br />
            {pageName == consts.SERVICE_REMOVAL_NAME ? <span dangerouslySetInnerHTML={{ __html: lookup.linkToSaveEnergy }} /> : null}
            {pageName == consts.NEW_GAS_LINE_NAME ?
                <div>
                    { !offRamp?
                    <div>
                    <div className="row">
                        <div className="col-sm-12">
                            <p>
                                <b>{lookup.sitePreparation.title}</b>
                                <br />
                            </p>
                            <span dangerouslySetInnerHTML={{ __html: lookup.sitePreparation.content }} />
                        </div>
                    </div>
                    {
                        isCrteditHistoryRequired ?
                            <div className="row">
                                <div className="col-sm-12">
                                    <p>
                                        <b>{lookup.creditHistory.title}</b>
                                        <br />
                                    </p>
                                    <span dangerouslySetInnerHTML={{ __html: lookup.creditHistory.content }} />
                                </div>
                            </div> : null
                    }
                    <br />
                    </div>
                    : null
                    }
                    <div className="row">
                        <div className="col-xs-6">
                            <ComeHomeToNaturalGas />
                        </div>
                        <div className="col-xs-6">
                            <SaveMoreWithRebates />
                        </div>
                    </div>
                    <br />
                    <div className="row">
                        <div className="col-xs-6">
                            <FindAGasContractor />
                        </div>
                        <div className="col-xs-6">
                            <HowMuchCanISave />
                        </div>
                    </div>
                </div>
                : null
            }
        </div>
    );
};

export default UsefulLinks;